/* TWRD 2026-10-21: hovering a colour or edition swatch on the PDP shows its name
   in the label next to "Colour:" / "Edition:". Leaving restores the current name.
   The name comes from the swatch's aria-label (title or img alt as fallback).
   The title attribute moves to data-twrd-name, so no browser tooltip doubles the label. */
(function () {
  'use strict';

  var OPT = '.twrd-colour-switch__opt, .twrd-edition-switch__opt';
  var LABEL = '.twrd-colour-switch__current, .twrd-edition-switch__current, .product-form__swatch__sub-title';

  function nameOf(opt) {
    var img = opt.querySelector('img');
    return opt.getAttribute('data-twrd-name') || opt.getAttribute('aria-label') ||
      opt.getAttribute('title') || (img && img.getAttribute('alt')) || '';
  }

  function bind(fieldset) {
    if (fieldset.dataset.twrdHover) return;
    var label = fieldset.querySelector(LABEL);
    if (!label) return;
    fieldset.dataset.twrdHover = '1';
    var current = label.textContent;

    function show(opt) { var n = nameOf(opt); if (n) label.textContent = n; }
    function restore() { label.textContent = current; }

    Array.prototype.forEach.call(fieldset.querySelectorAll(OPT), function (opt) {
      var n = nameOf(opt);
      if (n) opt.setAttribute('data-twrd-name', n);
      opt.removeAttribute('title');
      opt.addEventListener('mouseenter', function () { show(opt); });
      opt.addEventListener('mouseleave', restore);
      opt.addEventListener('focus', function () { show(opt); });
      opt.addEventListener('blur', restore);
    });
    window.addEventListener('pageshow', restore);
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-twrd-colour-switch], [data-twrd-edition-switch]'),
      bind
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
